import * as BetStatuses from 'constants/BetStatus';
import * as CashoutStatuses from 'constants/CashoutStatus';

export const selectUser = (state) => {
    return {
        user: state.auth.get('user')
    };
};

export const selectForLive = (state) => {
    const path = state.routing.locationBeforeTransitions !== null ?
        state.routing.locationBeforeTransitions.pathname :
        undefined;
    return {
        path,
        languageId: state.application.get('languageId'),
        version: state.application.get('live').get('version'),
        repoState: state.application.get('live').get('state')
    };
};

export const selectForTimetable = (state) => {
    const path = state.routing.locationBeforeTransitions !== null ?
        state.routing.locationBeforeTransitions.pathname :
        undefined;
    return {
        path,
        languageId: state.application.get('languageId'),
        version: state.application.get('timetable').get('version'),
        repoState: state.application.get('timetable').get('state')
    };
};

export const selectForBets = (state) => {
    const betHistory = state.application.get('betHistory');
    const keys = betHistory.keySeq().toList();

    const betArr = [];
    keys.map((betId) => {
        const bet = betHistory.get(betId);
        const betStatus = bet.get('betStatus');

        if (betStatus === BetStatuses.IN_DELAY || betStatus === BetStatuses.STAKE_REQUEST) {
            const stakeId = bet.get('stakeId');
            betArr.push({betId, stakeId});
        }
    });

    return {
        languageId: state.application.get('languageId'),
        bets: betArr
    };
};

export const selectForStakes = (state) => {
    const betHistory = state.application.get('betHistory');
    const keys = betHistory.keySeq().toList();

    const betArr = [];
    keys.map((betId) => {
        const bet = betHistory.get(betId);
        const betStatus = bet.get('betStatus');

        if (betStatus === BetStatuses.CONFIRMED) {
            const stakeId = bet.get('stakeId');
            betArr.push({betId, stakeId});
        }
    });

    return {
        bets: betArr
    };
};

export const selectForCashout = (state) => {
    const betHistory = state.application.get('betHistory');
    const keys = betHistory.keySeq().toList();

    const betArr = [];
    keys.map((betId) => {
        const bet = betHistory.get(betId);
        const betStatus = bet.get('betStatus');
        const cashout = bet.get('cashout');

        if (betStatus === BetStatuses.CONFIRMED && cashout) {
            const cashoutState = cashout.get('state');
            const requestId = cashout.get('requestId');
            if (cashoutState === CashoutStatuses.SELL_REQUESTED && requestId) {
                betArr.push({betId, requestId});
            }
        }
    });

    return {
        bets: betArr
    };
};



// WEBPACK FOOTER //
// ./js/sagas/selectors.js